export type ProductPayWithCoinsCardProps = {
  name: string;
  type: ProductPayWithCoinsType;
  id: number;
  domElement: Element;
};

export enum ProductPayWithCoinsType {
  CLASS = 'class',
  CRAFT = 'craft',
  BUNDLE = 'bundle',
}
